import { LocalDate } from "../../../shared/jsr310-localdates/types/local-date.type";

export enum TypeValideur {
	VALIDEUR = 'VALIDEUR', 
	VALIDEUR_INTERVENANT = 'VALIDEUR_INTERVENANT', 
	VALIDEUR_REPRESENTANT = 'VALIDEUR_REPRESENTANT', 
	VALIDEUR_REPRESENTANT_INTERVENANT = 'VALIDEUR_REPRESENTANT_INTERVENANT'
}

export class ValideurSignataireEntity {
    id!: number;
    planPreventionId!: number;
    intervenantId: number = -1;
    intervenantEntrepriseId: number = -1;
    intervenantEntrepriseNom!: string;
    sentToDocusign!: boolean;
    docusignEnvelopeId!: number;
    raisonSociale!: string;
    hasSigned!: boolean;
    fonction!: string;
    dateSignature!: string;
    hasSignedEnvelope!: boolean;
    docusignRecipientId!: string;
    cadreEmploi!: string;
    dateValidation!: LocalDate | null;
    email!: string;
	
	intervenant: boolean = false;
	typeValideur: TypeValideur = TypeValideur.VALIDEUR;
	nom!: string;
	prenom!: string;
	envelopeIndex!: number;
    updatable: boolean = true;
	emailStyle: string = '';
}